import { useEffect, useState } from "react";
import { useNavigate, useSearchParams, useLocation } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/common";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function PaymentResult() {
  const [sp] = useSearchParams();
  const loc = useLocation();
  const navigate = useNavigate();
  const sessionId = sp.get("session_id");
  const cancelled = loc.pathname.includes("cancel");
  const [state, setState] = useState(cancelled ? "cancel" : "checking");
  const [tries, setTries] = useState(0);

  useEffect(() => {
    if (cancelled || !sessionId) return;
    if (tries > 8) { setState("timeout"); return; }
    const t = setTimeout(async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") setState("paid");
        else if (["expired", "failed"].includes(data.payment_status)) setState("failed");
        else setTries((n) => n + 1);
      } catch { setTries((n) => n + 1); }
    }, 1500);
    return () => clearTimeout(t);
  }, [sessionId, tries, cancelled]);

  return (
    <div className="min-h-screen grid place-items-center bg-[#F8FAFC] p-6">
      <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-10 max-w-md w-full text-center">
        {state === "checking" && <><Loader2 className="animate-spin mx-auto text-sky-500 mb-4" size={44} /><h1 className="text-xl font-bold font-display text-slate-900">Verifica pagamento...</h1></>}
        {state === "paid" && <><CheckCircle2 className="mx-auto text-emerald-500 mb-4" size={52} /><h1 className="text-xl font-bold font-display text-slate-900">Pagamento completato!</h1><p className="text-slate-500 mt-2">L'operazione è stata registrata correttamente.</p></>}
        {(state === "cancel" || state === "failed") && <><XCircle className="mx-auto text-red-500 mb-4" size={52} /><h1 className="text-xl font-bold font-display text-slate-900">Pagamento non completato</h1><p className="text-slate-500 mt-2">Nessun addebito effettuato.</p></>}
        {state === "timeout" && <><Loader2 className="mx-auto text-amber-500 mb-4" size={44} /><h1 className="text-xl font-bold font-display text-slate-900">In elaborazione</h1><p className="text-slate-500 mt-2">Controlla tra poco lo stato aggiornato.</p></>}
        <Button className="mt-6 w-full" onClick={() => navigate("/app")} data-testid="payment-back-btn">Torna all'app</Button>
      </div>
    </div>
  );
}
